var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBillingHeader(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 600,
    height: 145,
    viewBox: "0 0 600 145",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3038_34628)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 600,
    height: 145,
    fill: "#004060"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1704.17 -1039.86L1161.16 752.754L17.9604 -224.362L1704.17 -1039.86Z",
    fill: "#00334D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M699.851 -107.28C709.669 -98.8079 706.768 -82.9039 694.59 -78.4452L-877.022 496.978C-889.366 501.498 -901.95 490.896 -899.59 477.963L-595.117 -1190.82C-592.758 -1203.75 -577.241 -1209.23 -567.288 -1200.64L699.851 -107.28Z",
    fill: "#002940"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3038_34628"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 600,
    height: 145,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBillingHeader);
export default __webpack_public_path__ + "static/media/billing-header.1f084f5609a3fe3c531af5e07743901a.svg";
export { ForwardRef as ReactComponent };